import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const SCIP = ({ userClaims }) => (
  <div className="min-h-screen bg-gray-100">
    <TopBar currentPage="scip" userClaims={userClaims} />
    <div className="p-4">
      <div className="bg-white shadow-md rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-800">Supply Chain Improvement Planning (SCIP)</h2>
          <a href="/scip-tool" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md">
            Open SCIP Tool
          </a>
        </div>
        <div className="w-full" style={{ height: '700px' }}>
          <PowerBIEmbed
            reportId="68738ad5-4879-4026-b951-ea7c8926e3c6"
            workspaceId="7d441575-4aa9-4260-99dd-543f002c0340"
            pageName="CIP Tracking"
            height={800}
          />
        </div>
      </div>
    </div>
  </div>
);

export default SCIP;